import React from 'react';
import { Redirect, Route, useLocation, useRouteMatch } from 'react-router-dom';
import PremiumValidation from './premiumValidation/premiumValidation.component';

export default function PremiumValidationRoutersComponent() {
  const { path } = useRouteMatch();
  const location = useLocation();

  //   const hasAccess = roleService.checkRouteAccess({ location });
  const hasAccess = true;

  return hasAccess ? (
    <Route exact path={path} component={PremiumValidation} />
  ) : (
    <Redirect
      to={{
        pathname: '/unauthorized',
        state: { from: location },
      }}
    />
  );
}
